import { TabNavigation } from 'src/common/TabNavigation';

export const _integrationTabs = [
  { name: 'Alivi', href: '/admin/alivi' },
  { name: 'Clearview', href: '/admin/clearview' },
  { name: 'Kinetik', href: '/admin/kinetik' },
  { name: 'Modivcare', href: '/admin/modivcare' },
  { name: 'Momentm', href: '/admin/momentm' },
  { name: 'MTM', href: '/admin/mtm' },
];

const tabs = [
  { name: 'Internal', href: '/admin/internal' },
  { name: 'Logs', href: '/admin/logs' },
  ..._integrationTabs,
];

export function AdminNav() {
  return <TabNavigation tabs={tabs} />;
}
